import type {MemexColumnDataType} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class NumberColumnModel extends BaseColumnModel {
  declare readonly id: number
  declare readonly dataType: typeof MemexColumnDataType.Number
  declare readonly userDefined: true
}
